<template>
    <div id="X15">
        <view1 :selectedProduct="selectedProduct" />
        <Tabs :activeTab.sync="activeTab" :tabs="radar" />
        <view2 :selectedProduct="selectedProduct" />
        <view3 :selectedProduct="selectedProduct" />
        <view4 :selectedProduct="selectedProduct" />
        <bottomview />
    </div>
</template>
<script>
import productData from '@/mixins/productData.js'
export default {
    name: 'Radar',
    mixins: [productData],
    components: {
        view1: () => import('@/views/Radar/view1.vue'),
        view2: () => import('@/views/Radar/view2.vue'),
        view3: () => import('@/views/Radar/view3.vue'),
        view4: () => import('@/views/Radar/view4.vue'),
        bottomview: () => import('@/views/ControlSystem/view4.vue'),
        Tabs: () => import('@/components/tabs.vue')
    },
    data() {
        return {
            activeTab: '',
            selectedProduct: null,
        }
    },
    watch: {
        '$route.query.code': {
            handler(newVal) {
                const code = newVal || '';
                this.activeTab = code;
            },
            immediate: true
        },
        activeTab: {
            handler(newVal) {
                const targetRoute = `/Radar?code=${newVal}`;
                const currentRoute = this.$route.fullPath;
                // 只有当目标路由与当前路由不同时才跳转，避免冗余导航错误
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        // 忽略 NavigationDuplicated 错误（Vue Router 3.x）
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
                this.selectedProduct = this.radar.find(item => item.code === newVal) || this.radar[0];
            },
            immediate: true
        }
    },

}
</script>
<style scoped>
    
</style>